module.exports = __webpack_public_path__ + "img/tiktok-iconbar.8a50bfe0.svg";